
import EoContainer from '../EoContainer/EoContainer.vue'

export default {
  name: 'EoToolbar',
  components: { EoContainer },
  props: {
    /**
     * Style: adds default padding
     */
    padded: {
      type: Boolean,
      default: false,
    },
    /**
     * Style: adds default padding to left and right
     */
    paddedX: {
      type: Boolean,
      default: false,
    },
    /**
     * Style: adds default padding to top and bottom
     */
    paddedY: {
      type: Boolean,
      default: false,
    },
    /**
     * Make one or more corners to be rounded (nw) (ne) (se) (sw) (all)
     */
    rounded: {
      type: [String, Array],
      validator: value => {
        if (value == '') return true
        if (Array.isArray(value)) {
          return value.every(item => ['nw', 'ne', 'se', 'sw'].indexOf(item) !== -1)
        } else {
          return ['nw', 'ne', 'se', 'sw', 'all'].indexOf(value) !== -1
        }
      },
      default: '',
    },
    /**
     * Style: background color of the toolbar
     */
    color: {
      type: String,
      default: null,
    },
    /**
     * Style: border color of the toolbar
     */
    borderColor: {
      type: String,
      default: null,
    },
    /**
     * Style: color of the text and icons
     */
    textColor: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      observer: null,
      hasLeft: false,
      hasCenter: false,
      hasRight: false,
    }
  },
  computed: {
    classes () {
      return {
        'eo-toolbar': true,
        'is-rounded-nw': !!this.rounded && (this.rounded == 'all' || this.rounded == 'nw' || this.rounded.includes('nw')),
        'is-rounded-ne': !!this.rounded && (this.rounded == 'all' || this.rounded == 'ne' || this.rounded.includes('ne')),
        'is-rounded-se': !!this.rounded && (this.rounded == 'all' || this.rounded == 'se' || this.rounded.includes('se')),
        'is-rounded-sw': !!this.rounded && (this.rounded == 'all' || this.rounded == 'sw' || this.rounded.includes('sw')),
        'has-left': this.hasLeft,
        'has-center': this.hasCenter,
        'has-right': this.hasRight,
        'has-border': !!this.borderColor,
        ['text--' + this.textColor]: !!this.textColor,
      }
    },
    classesBackground () {
      return {
        'eo-toolbar__background': true,
        ['text--' + this.borderColor]: !!this.borderColor,
        ['color--' + this.color]: !!this.color,
      }
    },
  },
  mounted () {
    this.watchSlotVisibility()
  },
  beforeDestroy () {
    this.unwatchSlotVisibility()
  },
  methods: {
    watchSlotVisibility () {
      // Use mutationObserver to find child changes, because $slots is not reactive
      this.getSlotVisibility()
      this.observer = new MutationObserver(this.getSlotVisibility)
      this.observer.observe(this.$refs.left, { childList: true })
      this.observer.observe(this.$refs.center, { childList: true })
      this.observer.observe(this.$refs.right, { childList: true })
    },
    unwatchSlotVisibility () {
      this.observer.disconnect()
    },
    async getSlotVisibility () {
      this.hasLeft = !!this.$slots.left || !!this.$slots.center
      this.hasCenter = !!this.$slots.center
      this.hasRight = !!this.$slots.right || !!this.$slots.center
    },
  },
}
